// based on https://oms.wff.ch/calc.htm
// GNU GPL v2 or later Licsense

export class LonLatToTiles {

    long2tile(lon: number, zoom1: number) {
        let tt = Number(lon);
        return (Math.floor((tt + 180) / 360 * Math.pow(2, zoom1)));
    }

    lat2tile(lat: number, zoom2: number) {
        return (Math.floor((1 - Math.log(Math.tan(lat * Math.PI / 180) + 1 / Math.cos(lat * Math.PI / 180)) / Math.PI) / 2 * Math.pow(2, zoom2)));
    }

    tile2long(x: number, z: number) {
        return (x / Math.pow(2, z) * 360 - 180);
    }

    tile2lat(y: number, z: number) {
        var n = Math.PI - 2 * Math.PI * y / Math.pow(2, z);
        return (180 / Math.PI * Math.atan(0.5 * (Math.exp(n) - Math.exp(-n))));
    }

}